import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  SUCCEEDED as FETCHING_STATUS_SUCCEEDED,
  IN_PROGRESS as FETCHING_STATUS_IN_PROGRESS,
} from 'constants/status/fetchingStatus';
import calculateTotalPrice from 'state/checkoutPage/travelSummary/selectors/calculateTotalPrice';
import PackagePriceComponent from './components/PackagePriceComponent';
import PackagePriceComponentTravelSummaryBar from './components/PackagePriceComponent.TravelSummaryBar';

export default function PackagePrice({ onTravelSummaryBar }) {
  const dispatch = useDispatch();

  const packagesSearchFetching = useSelector((state) => state.checkoutPagePackagesSearch.fetching);
  const changedUpgradePrice = useSelector(
    (state) =>
      state.checkoutPageFlightsDetails.changedUpgradePrice &&
      state.checkoutPageFlightsDetails.changedUpgradePrice.changed &&
      state.checkoutPageFlightsDetails.changedUpgradePrice.newPriceAccepted
  );
  const checkoutPageTravelSummary = useSelector((state) => state.checkoutPageTravelSummary); // Required for component update

  const isReady = packagesSearchFetching === FETCHING_STATUS_SUCCEEDED;

  if (packagesSearchFetching === FETCHING_STATUS_IN_PROGRESS) {
    return null;
  }

  const { totalPrice, pricePerPerson } = isReady || changedUpgradePrice ? dispatch(calculateTotalPrice()) : {};

  if (onTravelSummaryBar) {
    return <PackagePriceComponentTravelSummaryBar ready={isReady} pricePerPerson={pricePerPerson} />;
  }

  return <PackagePriceComponent ready={isReady} totalPrice={totalPrice} pricePerPerson={pricePerPerson} />;
}
